  import PropTypes from 'prop-types';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import {   useNavigate } from 'react-router-dom';
import { Booking } from 'src/modules/BookingManagement/models';
import { COLOR_CODE, I18N, ROLES } from 'src/shared/constants/constants';
import { FC, useState, useEffect } from 'react';
 
 
interface PastBookingTableProps {
  
  pastBookingData: Booking[];
}

const PastBookingTable: FC<PastBookingTableProps> = ({ 
  pastBookingData
}) => {
  
  const [userTableColumns, setuserTableColumns] = useState([]);
 
  const navigate = useNavigate();

  const { t } = useTranslation(I18N.DEFAULT);
  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'name',
      headerName: t('name'),
      sortable: false,
      flex: 1,
    },
    {
      field: 'billNo',
      headerName: t('booking.billNo'),
      filterable: false,
      flex: 1
    },
    {
      field: 'mobile',
      headerName: t('booking.mobile'),
      filterable: false,
      flex: 1
    },
    {
      field: 'deliveryDate',
      headerName: t('booking.deliverydate'),
      filterable: false,
      flex: 2,
      valueGetter: (params) => {
        if (params?.row?.deliveryDate) {
          const date: Date = new Date(params?.row?.deliveryDate);
          return `${date.toLocaleString('en-GB',{hour12: true}) || ''}`;
        }
        return '';
      }
    },
    {
      field: 'returnDate',
      headerName: t('booking.returndate'),
      filterable: false,
      flex: 2,
      valueGetter: (params) => {
        if (params?.row?.returnDate) {
          const date: Date = new Date(params?.row?.returnDate);
          return `${date.toLocaleString('en-GB',{hour12: true}) || ''}`;
        }
        return '';
      }
    },
  ];
  const getRowClassName = (params: GridRenderCellParams<any>) => {
    return params?.row?.colorCode ? `table-back-gound-${params.row.colorCode}` : `table-back-gound-${COLOR_CODE.DEFAULT}`;
  };
 
  useEffect(() => {
    if ( ROLES.TENANT_OPERATOR) {
      setuserTableColumns(columns);
    } else {
      setuserTableColumns([...columns ]);
    }
  }, []);
  return (
    <>
      <Card className="mb-24">
        <Tables
          rows={pastBookingData}
          getRowClassName={getRowClassName}
          columns={userTableColumns}
          checkboxSelection={false}
        />
      </Card>
    </>
  );
};

PastBookingTable.propTypes = {
  pastBookingData: PropTypes.array.isRequired
};

PastBookingTable.defaultProps = {
  pastBookingData: []
};

export default PastBookingTable;
